"use client";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { IconX } from "./icons.js";
import { IconButton } from "../components/Button.js";
/** The head of every window (Dialog, ConfirmDialog, Drawer): icon · title · extra · «×» at the top right (Jakob). */
export function DialogHead({ titleId, icon, title, extra, closeLabel, onClose, disabled }) {
    return _jsxs("header", { className: "jui-dialog-head", children: [_jsxs("h2", { id: titleId, className: "jui-dialog-title", children: [icon, title] }), extra, _jsx(IconButton, { className: "jui-dialog-close", label: closeLabel, icon: _jsx(IconX, {}), onClick: onClose, disabled: disabled })] });
}
